export default function PlaceholderCardImageSVG() {
  return (
    <>
      {/* prettier-ignore */}
      <svg width="100%" height="100%" viewBox="0 0 144.68 91.0772" preserveAspectRatio="xMidYMid slice" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="144.68" height="91.0772" fill="var(--theme-primary)"/>
        <mask id="mask0_9265_298" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="144.68" height="91.0772">
        <rect x="0" y="0" width="144.68" height="91.0772" fill="#ED713C"/>
        </mask>
        <g mask="url(#mask0_9265_298)">
        <ellipse opacity="0.1" cx="11.9677" cy="105.769" rx="74.1044" ry="55.9746" fill="black"/>
        <ellipse opacity="0.08" cx="134.593" cy="-13.7698" rx="74.1044" ry="55.9746" fill="black"/>
        </g>
      </svg>
    </>
  );
}
